import { render, staticRenderFns } from "./CreateMyPlan.vue?vue&type=template&id=13668300&"
import script from "./CreateMyPlan.vue?vue&type=script&lang=js&"
export * from "./CreateMyPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports